module.exports = __webpack_public_path__ + "static/media/icon-cookie.f5441460.svg";